import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class LocationTypeModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (LocationTypeModel._instance == null) LocationTypeModel._instance = new LocationTypeModel(authManager);
        return LocationTypeModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'sites/location-types', 'sites/location-types/codelist');

        this.entityName = 'sites.LocationType';
        this.privileges = {
            create: [["adminSites"]],
            read: [["adminSites"],["manageSites"],["editSites"],["readSites"]],
            update: [["adminSites"]],
            delete: [["adminSites"]],
        };

        this.label = 'Location Type';
        this.setLabel = 'Location Types';

        this.browser = {
            name: 'default-sites-locationtype-browser',
            moduleName: 'default-sites-locationtype-browser',
            moduleTitle: 'Location Types',
            moduleStateSlotName: 'default-sites-locationtype-browser',
        };

        this.editor = {
            name: 'default-sites-locationtype-editor',
            moduleName: 'default-sites-locationtype-editor',
            moduleTitle: 'Location Type',
            moduleStateSlotName: 'default-sites-locationtype-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
